var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position.show),expression:"position.show"}],staticClass:"list"},_vm._l((2),function(n){return _c('div',{key:n,ref:"roll",refInFor:true,style:({
      '--positionTop': `-${_vm.height || _vm.position.h - 2}px`,
      '--positionLeft': `-${_vm.width || _vm.position.w - 2}px`,
      '--translateY': `-${_vm.height || _vm.position.h - 2}px`,
      '--translateX': `${_vm.width || _vm.position.w - 2}px`
    })},[_c('table',{ref:"table",refInFor:true,staticClass:"table",style:({
        width: `${_vm.width || _vm.position.w - 2}px`,
        height: `${_vm.height || _vm.position.h - 2}px`,
        borderCollapse: 'collapse',
        tableLayout: 'fixed'
      })},_vm._l((_vm.option.rows),function(row){return _c('tr',{key:row,style:(_vm.rowStyle(row, _vm.option.rows))},_vm._l((_vm.option.columns),function(col){return _c('td',{key:col,style:(_vm.colStyle(col, _vm.option.columns))},[_c('span',{staticStyle:{"display":"inline-block","margin-left":"0px"}},[_vm._v(_vm._s(_vm.handleTableData(row, col)))])])}),0)}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }